import styles from './ReferralBanner.scss';

import React, { RefObject } from 'react';
import { ScrollDirection } from '../NavBar/NavBarUtil';
import { useResponsive } from '../Responsive/Responsive';
import { ReferralBannerDesktop } from './ReferralBannerDesktop';
import { ReferralBannerMobile } from './ReferralBannerMobile';

export type Props = {
  mainContentRef?: RefObject<HTMLDivElement>;
  scrollDirection?: ScrollDirection;
  wrapperGroupRef?: RefObject<HTMLDivElement>;
};

export const ReferralBanner: React.FC<Props> = ({ mainContentRef, scrollDirection, wrapperGroupRef }) => {
  const { browser } = useResponsive();
  const mobile = browser.is.mobile || browser.is.tablet;
  if (mobile) {
    return <ReferralBannerMobile mainContentRef={mainContentRef} navHeight={styles.navUp} paddingTop={styles.paddingTop} scrollDirection={scrollDirection} wrapperGroupRef={wrapperGroupRef} />;
  }
  return <ReferralBannerDesktop mainContentRef={mainContentRef} navHeight={styles.navUp} paddingTop={styles.paddingTop} scrollDirection={scrollDirection} wrapperGroupRef={wrapperGroupRef} />;
};
